import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { from as observableFrom, Observable } from 'rxjs';
import { PermissionResponse } from '../core/base-api';
import { switchMap } from 'rxjs/operators';
import { SecurityData } from './security-data';
import { AppPermissionService } from '../core/services/app-permission.service';
import { environment } from 'environments/environment';
import { CapiLoginService } from 'app/core/extension/login/capi-login-service';
import { AppFormatConfigService } from '../core/services/app-format-config.service';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

export const canActivateAuthorization: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> | Promise<boolean> | boolean => {
  return new Promise<boolean>((resolve) => {
    const loginService = inject(CapiLoginService);
    const securityData = inject(SecurityData);
    const router = inject(Router);
    const permissionService = inject(AppPermissionService);
    const appFormatConfigService = inject(AppFormatConfigService);
    let isAnonymUserAllowed: boolean = false;
    appFormatConfigService.parameterConfig$.subscribe((config) => {
      isAnonymUserAllowed = <any>config?.parameters.ZUGELASSENE_BENUTZERKATEGORIEN === 'REGISTRIERT';
    });
    observableFrom(loginService.requireLogin(state.url))
      .pipe(switchMap(() => permissionService.permissions$))
      .subscribe((userPermissions) => {
        securityData.actionUrl = state.url;
        const requiredPermissions: PermissionsEnum[] = route.data.permissions;
        if (requiredPermissions && !requiredPermissions.some((permission) => userPermissions.includes(permission))) {
          if (anonymUserAllowed(userPermissions, requiredPermissions) && !isAnonymUserAllowed) {
            resolve(true);
            return;
          }
          if (loginService.userLoggedIn && !userPermissions.includes(PermissionsEnum.LOGIN)) {
            router.navigate(['unauthorized']);
          } else if (loginService.userLoggedIn) {
            router.navigate(['security/forbidden']);
          }
          resolve(false);
        }
        resolve(true);
      });
  });
};

function anonymUserAllowed(userPermissions: PermissionResponse.PermissionsEnum[], requiredPermissions: PermissionsEnum[]) {
  const noUserPermissions = userPermissions.length === 0;
  const deploymentModePublic = environment.deploymentMode === 'PUBLIC';
  const anonymUserAllowedForRoute = requiredPermissions.some((permission) => permission.includes(PermissionsEnum.ANONYM));
  return deploymentModePublic && noUserPermissions && anonymUserAllowedForRoute;
}
